import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
      <Link to="/" className="cursor-pointer transition-colors hover:text-primary-700">
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-foreground-400" />
          {item.to ? (
            <Link to={item.to} className="cursor-pointer transition-colors hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="max-w-[220px] truncate text-foreground-800 md:max-w-none">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}